import { FacilityState, ISearchState } from './../../models/search';
import { SearchState } from './state';
import {createFeatureSelector, createSelector} from '@ngrx/store';


export const updateHeaderType = createFeatureSelector<any>('search');

export const FacilitiesSelector = createSelector(
  updateHeaderType, (state: ISearchState) => state.facilities
);

export const getFacilities = createSelector(
  updateHeaderType,
  (state: ISearchState) => {
    return state.facilities;
  }
);

export const getRoomFacilities = createSelector(
  updateHeaderType,
(state: ISearchState) => {
  return state.roomFacilities;
}
);

export const getExtraFacilities = createSelector(
  updateHeaderType,
(state: ISearchState) => {
  return state.optionalCategories;
}
);
